import React, { Component } from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 rounded-xl font-bold text-lg transition-all duration-300 shadow-sm hover:shadow-md active:scale-[0.98]';
  const variants = {
    primary: 'bg-terracota text-white hover:bg-terracota-dark',
    secondary: 'bg-white text-terracota border-2 border-terracota hover:bg-orange-50'
  };
  const widthClass = fullWidth ? 'w-full' : 'w-full md:w-auto';
  const Component = href ? motion.a : motion.button;
  const componentProps = href ? {
    href,
    className: `${baseStyles} ${variants[variant]} ${widthClass} ${className}`,
    onClick: props.onClick as any
  } : {
    className: `${baseStyles} ${variants[variant]} ${widthClass} ${className}`,
    ...props
  };
  return <Component {...componentProps as any} data-id="element-245">{children}</Component>;
}